'use strict'

var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

module.exports = function (ngModule) {
  ngModule
    .controller('HeaderCtrl', ["$rootScope", "$scope", "$location", "$log", "Auth", function ($rootScope, $scope, $location, $log, Auth) {
      $scope.bcDownloadLink = window.localStorage.getItem('PG_BC_DOWNLOAD_LINK')
      $scope.userObj = {
        thumbnail: Auth.getUserThumbnail()
      }

      var updateIcon = $scope.$on('user:icon', function () {
        $scope.userObj.thumbnail = Auth.getUserThumbnail()
      })

      $scope.$on('$destroy', function () {
        updateIcon()
      })

      $scope.toggled = function (open) {
        $log.debug('Dropdown is now: ', open)
      }

      $scope.doLogin = function () {
        $log.debug('doLogin')
        $location.path('/login')
      }

      $scope.doLogout = function () {
        $log.debug('doLogout')
        Auth.logoutUser()
        $location.path('/login')
        window.localStorage.removeItem('PG_BC_DOWNLOAD_LINK')
      }

      $scope.showDropdown = false
      $scope.showMenu = function () {
        $scope.showDropdown = true
      }
      $scope.hideMenu = function () {
        $scope.showDropdown = false
      }
    }])
    .controller('CallbackCtrl', ["$rootScope", "$scope", "$location", "$window", "$log", "Auth", function ($rootScope, $scope, $location, $window, $log, Auth) {
      var allQueryParams = $location.search()
      if (_.has(allQueryParams, 'token')) {
        Auth.loginUser(allQueryParams.token)
      }
      if (_.has(allQueryParams, 'error') && _.has(allQueryParams, 'redirect')) {
        $location.path('/' + allQueryParams.redirect + '?error=' + allQueryParams.error)
      } else {
        if (_.has(allQueryParams, 'redirect')) {
          $window.location.href = allQueryParams.redirect + '?pg_token=' + allQueryParams.token
        } else {
          $location.path('/')
        }
      }
    }])
    .controller('AuthCtrl', ["$rootScope", "$scope", "$location", "$log", "$uibModal", "$auth", "$window", "$httpParamSerializer", "Auth", "$translate", "Analytics", function ($rootScope, $scope, $location, $log, $uibModal, $auth, $window, $httpParamSerializer, Auth, $translate, Analytics) {
      $scope.currentLanguage = $translate.proposedLanguage()
      $scope.alerts = []
      $scope.members = []
      var allQueryParams = $location.search()
      var allLinks = {
        'signup': '/signup',
        'signin': '/login',
        'store_signup': '/store_signup',
        'store_signin': '/store_auth',
        'password': '/req_password'
      }

      var currentPath = $location.path()
      $log.debug('path', currentPath)
      if (currentPath.match('store_signup') || currentPath.match('store_auth')) {
        $window.AppleID.auth.init({
          clientId: 'com.positivegrid.pgaccount',
          scope: 'name email',
          redirectURI: window.location.origin + '/api/oauth/bc_apple',
          state: 'pg-apple-bc-signin'
        })
      } else {
        $window.AppleID.auth.init({
          clientId: 'com.positivegrid.pgaccount',
          scope: 'name email',
          redirectURI: window.location.origin + '/api/oauth/apple',
          state: 'pg-apple-signin'
        })
      }

      $log.log('allQueryParams', $scope.user, allQueryParams);
      if (!$scope.user) $scope.user = {};
      if (currentPath.match('store_auth')) {
        $scope.user.username = decodeURIComponent(allQueryParams.email || '');
      }
      if (currentPath.match('store_signup')) {
        $scope.user.uemail = decodeURIComponent(allQueryParams.email || '');
        $scope.user.fname = decodeURIComponent(allQueryParams.fname || '');
        $scope.user.lname = decodeURIComponent(allQueryParams.lname || '');
      }

      if (_.has(allQueryParams, 'error')) {
        $scope.alerts.push({ type: 'danger', message: allQueryParams.error })
      }

      $scope.getLink = function (path) {
        if (!_.has(allLinks, path)) {
          $log.debug('Cannot find target link: ', path)
        } else {
          return (_.isEmpty(allQueryParams))
            ? $location.path(allLinks[path])
            : $location.path(allLinks[path]).search(allQueryParams)
        }
      }

      $scope.backToStore = function () {
        var host = window.location.host
        var queryParams = $location.search()
        var backToPath = (queryParams && queryParams.back_to)
          ? String(queryParams.back_to).replace('/', '')
          : 'plugins'

        switch (host) {
          case 'pg-usercenter-staging.herokuapp.com':
            window.location.href = 'https://bcsbx.positivegrid.com/' + backToPath
            break
          case 'account.positivegrid.com':
            window.location.href = 'https://www.positivegrid.com/' + backToPath
            break
          default:
            window.location.href = 'https://www.positivegrid.com/' + backToPath
        }

        if (currentPath.match('checkout')) Analytics.trackEvent('product', 'guest_checkout');
      }

      function resetNotification() {
        $scope.alerts = []
      }

      function validateForLogIn() {
        resetNotification()
        var user = $scope.user || {}
        var username = user.username || ''
        var password = user.password || ''
        var isEmailValid = username.length > 0 && EMAIL_REGEX.test(username)
        var isPasswordValid = password.length > 0
        if (!isEmailValid) { $scope.alerts.push({ type: 'danger', message: 'Invalid email' }) } else if (!isPasswordValid) { $scope.alerts.push({ type: 'danger', message: 'Password is required' }) }
        return isEmailValid && isPasswordValid
      }

      function validateForSignUp() {
        resetNotification()
        var user = $scope.user || {}
        var uemail = user.uemail || ''
        var password = user.password || ''
        var fname = user.fname || ''
        var lname = user.lname || ''

        var isEmailValid = uemail.length > 0 && EMAIL_REGEX.test(uemail)
        var isPasswordValid = password.length > 0
        var isFirstNameValid = fname.length > 0
        var isLastNameValid = lname.length > 0
        var isPasswordMatchToConfirmation = password === user.passwordConfirm
        var isAgreePrivacyPolicy = user.privacy

        if (!isFirstNameValid) { $scope.alerts.push({ type: 'danger', message: 'First name is required' }) } else if (!isLastNameValid) { $scope.alerts.push({ type: 'danger', message: 'Last name is required' }) } else if (!isEmailValid) { $scope.alerts.push({ type: 'danger', message: 'Invalid email' }) } else if (!isPasswordValid) { $scope.alerts.push({ type: 'danger', message: 'Password is required' }) } else if (!isPasswordMatchToConfirmation) { $scope.alerts.push({ type: 'danger', message: 'Password and confirmation password do not match' }) } else if (!isAgreePrivacyPolicy) { $scope.alerts.push({ type: 'danger', message: 'Please agree to the privacy policy' }) }

        return isEmailValid &&
          isPasswordValid &&
          isFirstNameValid &&
          isLastNameValid &&
          isPasswordMatchToConfirmation &&
          isAgreePrivacyPolicy
      }

      function gaEventLoginTrigger(ga) {
        if ($location.search().hasOwnProperty('pid')) {
          try {
            var searchObject = $location.search()
            var pidArr = searchObject['pid'].split(',')
            var pNameArr = searchObject['pname'].split(',')
            var priceArr = searchObject['price'].split(',')
            var qtyArr = searchObject['qty'].split(',')
            // Analytics.addProduct('productId', 'name', 'category', 'brand', 'variant', 'price', 'quantity', 'coupon', 'position')
            for (var i = 0, len = pidArr.length; i < len; i++) {
              ga.addProduct(pidArr[i], pNameArr[i], '', '', '', priceArr[i], qtyArr[i], '', '')
            }
            ga.trackCheckout(2)
            ga.pageView()
          } catch (err) {
            console.log(err)
          }
        }
      }

      $scope.userLogin = function () {
        $log.debug('userLogin', $scope.user)
        resetNotification()

        Auth.userLogin($scope.user)
          .then(function (resp) {
            $log.debug('userLogin:success', resp)
            if (_.has(allQueryParams, 'redirect')) {
              $location.path(allQueryParams.redirect)
            } else {
              $location.path('/profile')
            }
          })
          .catch(function (error) {
            $log.debug('userLogin:failure', error)
            $scope.alerts.push({ type: 'danger', message: error })
          })
      }
      $scope.loginOauth = function (type) {
        resetNotification()

        $auth.authenticate(type)
          .then(function (resp) {
            $log.debug('loginOauth', resp, resp.status)
            if (resp.status === 200) {
              $log.debug('login', resp.status, resp.data)
              if (resp.data && resp.data.token) {
                Auth.loginUser(resp.data.token)
                if (_.has(allQueryParams, 'redirect')) {
                  $log.debug('login:todirect', allQueryParameter.redirect)
                  $location.path(allQueryParams.redirect)
                } else {
                  $log.debug('login:toprofile')
                  $location.path('/profile')
                }
              } else {
                $log.debug('login:invalidP')
                $location.path('/login')
              }
            } else {
              $scope.alerts.push({
                'type': 'danger',
                'message': 'something wrong!'
              })
            }
          })
          .catch(function (err) {
            $log.debug(err)
            var message = (err.data && err.data.message)
              ? err.data.message : String(type).toUpperCase() + ' login failed'

            $scope.alerts.push({
              'type': 'danger',
              'message': message
            })
          })
      }

      $scope.loginBigCommerce = function (authType) {
        var isValid = validateForLogIn()
        if (!isValid) return

        var queryParams = $location.search()
        queryParams['region'] = window.localStorage.getItem('PG_LANG')

        Auth.userLogin($scope.user, authType, queryParams)
          .then(function (resp) {
            $log.debug('login: ', resp, authType, allQueryParams)
            window.localStorage.setItem('PG_BC_DOWNLOAD_LINK', resp['bcDownloadLink'])
            gaEventLoginTrigger(Analytics)
            if (currentPath.match('checkout')) Analytics.trackEvent('product', 'checkout_log_in');
            if (allQueryParams.redirect_to === '/checkout/order-confirmation')
              Analytics.trackEvent('product', 'log_in_after_checkout');
            if ((_.has(queryParams, 'redirect_to') || _.has(queryParams, 'redirect_host')) &&
              (_.has(resp, 'token') && (/^https/.test(resp.token) || /^http/.test(resp.token)))) {
              $window.location.href = resp.token
            } else if (_.has(allQueryParams, 'redirect')) {
              if (allQueryParams.redirect === 'bc' && _.has(resp, 'token') && _.has(resp, 'pg_token')) {
                $window.location.href = resp.token
              } else {
                $location.path(allQueryParams.redirect)
              }
            } else {
              $scope.alerts.push({ type: 'danger', message: 'Did not pass store auth' })
              $location.path('/profile')
            }
          })
          .catch(function (error) {
            $log.debug('userLogin:failure', error)
            $scope.alerts.push({ type: 'danger', message: error })
          })
      }

      $scope.loginOauthBigCommerce = function (type, redirecTo) {
        resetNotification()
        var ga = Analytics
        $auth.authenticate(type)
          .then(function (resp) {
            $log.debug('loginOauthBigCommerce', resp)
            gaEventLoginTrigger(ga)
            if (currentPath.match('checkout')) Analytics.trackEvent('product', 'checkout_log_in');
            if (allQueryParams.redirect_to === '/checkout/order-confirmation')
              Analytics.trackEvent('product', 'log_in_after_checkout');
            if (resp.status === 200) {
              if (resp.data && resp.data.redirect && resp.data.token) {
                Auth.loginUser(resp.data.token)
                var queryParams = $location.search()
                queryParams['region'] = window.localStorage.getItem('PG_LANG')
                if (_.has(queryParams, 'redirect_to') || _.has(queryParams, 'redirect_host')) {
                  $location.path('/profile')
                } else if (redirecTo === 'bc') {
                  $window.location.href = resp.data.redirect + '?token=' + resp.data.token
                } else if (_.has(queryParams, 'redirect')) {
                  $location.path(queryParams.redirect)
                } else {
                  $location.path('/profile')
                }
              } else {
                $location.path('/profile')
              }
            } else {
              $scope.alerts.push({
                'type': 'danger',
                'message': 'something wrong!'
              })
            }
          })
          .catch(function (err) {
            $log.debug(err)
            var message = (err.data && err.data.message)
              ? err.data.message : String(type).toUpperCase() + ' login failed'

            $scope.alerts.push({
              'type': 'danger',
              'message': message
            })
          })
      }

      $scope.addMembers = function ($event) {
        $event.stopPropagation()

        // Maximum members would be 3
        if ($scope.members.length < 3) {
          $scope.members.push({ email: '' })
        }
      }
      $scope.removeMember = function ($event, $idx) {
        $event.stopPropagation()
        $scope.members.splice($idx, 1)
      }

      $scope.signupUser = function (version) {
        var isValid = validateForSignUp()
        if (!isValid) return

        var members = _($scope.members)
          .filter(function (item) {
            return (item.email && item.email !== '')
          })
          .map(function (member) {
            return member.email
          })
          .valueOf()
        var signupData = _.assign({}, $scope.user, { members: members })
        $log.debug('signup data:', signupData)

        Auth.userSignup(signupData, version)
          .then(function (resp) {
            $log.debug('signupUser:Success', resp)
            if (
              version !== 'b2b' &&
              $window.exponea &&
              signupData &&
              signupData.uemail
            ) {
              $log.debug('send exponea', signupData.uemail)
              $window.exponea.track('registration', {
                'email': signupData.uemail
              });
              var categories = ['email'];
              var timestamp = Date.now();
              categories.forEach(function (category) {
                $window.exponea.track('consent',
                  {
                    action: 'accept',
                    category: category,
                    timestamp: timestamp,
                    valid_until: 'unlimited',
                    label: 'toneCloud',
                    email: signupData.uemail
                  }
                );
              });
            }

            if (allQueryParams.redirect_to === '/checkout/order-confirmation') {
              Analytics.trackEvent('product', 'sign_up_after_checkout')
            }

            var signupModal = $uibModal.open({
              templateUrl: 'template/partial/modal.html',
              controller: 'ModalInstanceCtrl',
              size: 'lg',
              resolve: {
                displayData: {
                  title: 'SIGNUP_SUCCESS',
                  subtitle: 'PLEASE_LOGIN'
                }
              }
            })

            signupModal.result.then(function (result) {
              if (version === 'v2') {
                var target = window.location.pathname === '/signup' ? '/login' : '/store_auth'
                var query = $location.search()
                if (!_.isEmpty(query)) {
                  $window.location.href = target + '?' + $httpParamSerializer(query)
                } else {
                  $location.path(target)
                }
              } else if (version === 'b2b') {
                $location.path('/login')
              } else {
                $location.path('/login')
              }
            })
          }).catch(function (err) {
            $log.debug('signupUser:Error', err)
            var message = (err.data && err.data.errorMessage)
              ? err.data.code || err.data.errorMessage
              : 'Signup failure, please try again'

            $scope.alerts.push({
              'type': 'danger',
              'message': message
            })
          })
      }

      $scope.bcSignup = function () {
        var query = $location.search()
        if (_.isEmpty(query)) {
          $location.path('/store_signup?' + $httpParamSerializer(query))
        } else {
          $location.path('/store_signup')
        }
      }

      $scope.passwordResetPopup = function () {
        var resetModal = $uibModal.open({
          templateUrl: 'template/modal/reset.html',
          controller: 'ResetInstanceCtrl',
          size: 'lg'
        })
      }
    }])
    .controller('MigrateProfileCtrl', ["$rootScope", "$scope", "$log", "$location", "$window", "Auth", function ($rootScope, $scope, $log, $location, $window, Auth) {
      $scope.alerts = []

      function resetNotification() {
        $scope.alerts = []
      }

      $scope.updateUserName = function () {
        resetNotification()

        var queryParams = $location.search()
        Auth.migrateFirstLastName($scope.user, queryParams)
          .then(function (resp) {
            $log.debug('migrate', $scope.user, resp)
            if (_.has(queryParams, 'redirect')) {
              if (queryParams.redirect === 'bc') {
                $window.location.href = resp.data.token
              } else if (queryParams.redirect === 'account') {
                $location.path('/profile')
              } else {
                $location.path(queryParams.redirect)
              }
            } else {
              $window.location.href = resp.data.token
            }
          })
          .catch(function (err) {
            $log.debug('migrate:error', err)
            var message = (err.data && err.data.errorMessage)
              ? err.data.errorMessage
              : 'Update failure, please try again or report the issue'

            $scope.alerts.push({
              'type': 'danger',
              'message': message
            })
          })
      }
    }])
    .controller('ActivateCtrl', ["$rootScope", "$scope", "$location", "$log", "Auth", "ActivateData", function ($rootScope, $scope, $location, $log, Auth, ActivateData) {
      $log.debug('ActivateCtrl', ActivateData)
      if (ActivateData.result === 'SUCCESS') {
        $scope.activate = {
          success: true,
          email: ActivateData.email
        }
      } else if (ActivateData.result === 'INVALID') {
        $location.path('/')
      } else {
        $scope.activate = {
          success: false,
          email: ActivateData.email,
          message: ActivateData.message
        }
      }
    }])
    .controller('PasswordResetCtrl', ["$scope", "$location", "$log", "PgApi", function ($scope, $location, $log, PgApi) {
      $scope.resetObj = {}
      $scope.message = {
        success: false,
        value: '',
        storeHost: __bcHost__
      }

      var resetParams = $location.search()
      $log.debug('PasswordResetCtrl', resetParams, $scope.storeHost)
      if (!resetParams.tk) {
        $location.path('/')
      }

      $scope.doResetPassword = function () {
        var opts = {}
        if (resetParams && resetParams.type && resetParams.type === 'migration') {
          opts['type'] = resetParams.type
        }
        PgApi.doResetPassword(resetParams.tk, $scope.resetObj.resetPassword, opts)
          .then(function (data) {
            $scope.message['success'] = true
          }).catch(function (err) {
            $scope.message['success'] = false
            $scope.message['value'] = err.data.code || err.data.errorMessage || err.toString()
            $log.debug('doResetPassword', err, $scope.message)
          })
      }
    }])
    .controller('ReqPasswordCtrl', ["$scope", "$log", "PgApi", "$translate", function ($scope, $log, PgApi, $translate) {
      $scope.reset = { userEmail: '' }
      $scope.alerts = []

      $scope.sendPwdReset = function () {
        if ($scope.alerts.length > 0) {
          $scope.alerts = []
        }

        PgApi.reqResetPwd($scope.reset.userEmail, $translate.proposedLanguage())
          .then(function (resp) {
            $scope.alerts.push({
              type: 'normal',
              message: 'AUTH_CODE_SENT'
            })
          })
          .catch(function (err) {
            $scope.alerts.push({
              type: 'danger',
              message: err.msg
            })
          })
      }
    }])
    .controller('MainCtrl', ["$rootScope", "$scope", "$window", "$document", "$http", "$log", "$location", "$timeout", "$uibModal", "Upload", "Basic", "Auth", "UserData", function ($rootScope, $scope, $window, $document, $http, $log, $location, $timeout, $uibModal, Upload, Basic, Auth, UserData) {
      function _getCurrentUserAvatar() {
        var timestamp = new Date().getTime()
        return (UserData.userprofile.profile_thumb_url)
          ? UserData.userprofile.profile_thumb_url + '?' + timestamp
          : '/images/default-picture.png?' + timestamp
      }

      $scope.user = {
        email: UserData.email,
        fullname: UserData.userprofile.full_name,
        fname: UserData.userprofile.first_name,
        lname: UserData.userprofile.last_name,
        avatar: _getCurrentUserAvatar(),
        isB2b: (UserData.user_role === 4)
      }
      if (UserData.user_role === 4) {
        $scope.user['b2bdata'] = UserData.b2bprofile
        if (!$scope.user.b2bdata.members) {
          $scope.user.b2bdata.memberlist = []
        } else if (_.isArray($scope.user.b2bdata.members)) {
          $scope.user.b2bdata.memberlist = _.map($scope.user.b2bdata.members, function (member) {
            return { email: member }
          })
        }
      }
      $log.debug('mainuser', $scope.user)

      $scope.info = {
        username: false,
        email: false,
        password: false,
        b2b: false,
        b2b_members: false
      }

      $scope.angle = {
        username: 'fa-angle-down',
        email: 'fa-angle-down',
        password: 'fa-angle-down',
        b2b: 'fa-angle-down',
        b2b_members: 'fa-angle-down'
      }

      $scope.message = {
        username: {
          message: '',
          classname: ''
        },
        password: {
          message: '',
          classname: ''
        }
      }

      $scope.resetProfile = function (key) {
        switch (key) {
          case 'fullname':
            // $scope.user.fullname = UserData.userprofile.full_name
            $scope.user.fname = UserData.userprofile.first_name
            $scope.user.lname = UserData.userprofile.last_name
            break
          case 'password':
            $scope.user.password = ''
            break
          case 'b2b_members':
            $scope.user.b2bdata.members = []
            break
          default:
            $log.debug('Do not do', key)
        }
        $log.debug('resetProfile', key, UserData[key])
      }

      $scope.showInfo = function (info) {
        if (info in $scope.info) {
          $scope.info[info] = $scope.info[info] === false
          $scope.angle[info] = $scope.info[info] === false ? 'fa-angle-down' : 'fa-angle-up'
        }
      }

      $scope.addMembers = function ($event) {
        $event.stopPropagation()
        if (!$scope.user.b2bdata.memberlist) {
          $scope.user.b2bdata.memberlist = []
          $scope.user.b2bdata.memberlist.push({})
        } else if ($scope.user.b2bdata.memberlist && $scope.user.b2bdata.memberlist.length < 3) {
          $scope.user.b2bdata.memberlist.push({})
        } else {
          $log.debug('Not allow to add more members!')
        }
      }

      $scope.removeMember = function ($event, $idx) {
        $event.stopPropagation()
        if ($idx >= 0) {
          $scope.user.b2bdata.memberlist.splice($idx, 1)
        }
      }

      $scope.updateProfile = function (key) {
        var updateObj = {}
        switch (key) {
          case 'username':
            updateObj['fname'] = $scope.user.fname
            updateObj['lname'] = $scope.user.lname
            updateObj['fullname'] = $scope.user.fname + ' ' + $scope.user.lname
            break
          case 'password':
            updateObj['password'] = $scope.user.password
            break
          case 'b2b':
            updateObj['business_name'] = $scope.user.b2bdata.business_name
            updateObj['business_address'] = $scope.user.b2bdata.business_address
            updateObj['business_phone'] = $scope.user.b2bdata.business_phone
            _.forEach(['business_website', 'business_tax_id', 'business_vat_id'], function (item) {
              if ($scope.user.b2bdata[item] && !_.isEmpty($scope.user.b2bdata[item])) {
                updateObj[item] = $scope.user.b2bdata[item]
              }
            })
            updateObj['members'] = _($scope.user.b2bdata.memberlist)
              .filter(function (item) {
                return (item.email && item.email !== '')
              })
              .map(function (member) {
                return member.email
              })
              .valueOf()
            break
          default:
            $log.debug('Not support key: ', key)
        }

        $log.debug('updateProfile: ', updateObj)
        Auth.updateUserData(updateObj, key)
          .then(function (resp) {
            $timeout(function () {
              $scope.message[key] = {
                text: 'PROFILE_UPDATE_SUCCESS',
                classname: 'success-message'
              }
            })
          }).catch(function (error) {
            $timeout(function () {
              $scope.message[key] = {
                text: 'PROFILE_UPDATE_FAIL',
                classname: 'error-message'
              }
            })
          })
      }

      $scope.updateAvatar = function (fileInput) {
        var reader = new FileReader()
        reader.onload = function (evt) {
          $scope.user.avatar = _getCurrentUserAvatar()
          $scope.$apply(function ($scope) {
            if (!evt.target.result) return false

            var modalInstance = $uibModal.open({
              templateUrl: 'template/partial/avatar.html',
              controller: 'AvatarInstanceCtrl',
              size: 'lg',
              resolve: {
                avatar: function () {
                  return evt.target.result
                }
              }
            })

            modalInstance.result.then(function (avatarData) {
              $log.debug('closeAvatar', avatarData)
              if (avatarData) {
                Upload.upload({
                  url: 'api/user',
                  method: 'PUT',
                  data: { avatar: Basic.dataURItoBlob(avatarData) },
                  headers: Auth.getJwtHeader()
                }).then(function (resp) {
                  $timeout(function () {
                    $log.debug('avatar upload', resp)
                    if (_.has(resp, 'data.user.userprofile.profile_thumb_url')) {
                      $scope.user.avatar = resp.data.user.userprofile.profile_thumb_url
                    }
                  })
                }, function (err) {
                  $log.error(err)
                })
              }
            }).catch(function (err) {
              $log.debug('closeAvatar:Error', err)
              $scope.user.avatar = _getCurrentUserAvatar()
            })
          })
        }

        if (fileInput && fileInput instanceof Blob) {
          reader.readAsDataURL(fileInput)
        }
      }
    }])
    .controller('LandingCtrl', ["$rootScope", "$scope", "$log", "checkAuth", function ($rootScope, $scope, $log, checkAuth) {
      $log.debug('Landing...')
    }])
    .controller('MessengerCtrl', ["$rootScope", "$scope", "$log", "MessengerData", function ($rootScope, $scope, $log, MessengerData) {
      $scope.messenger = MessengerData
    }])
}



//////////////////
// WEBPACK FOOTER
// ./js/controllers/main.js
// module id = 50
// module chunks = 0